"use client";

import React from "react";

interface NoWebinarsProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

/**
 * Friendly empty state shown when there are no active webinars (on the events
 * list) or the requested webinar has passed / doesn't exist (on the detail
 * page) — instead of an error or a blank screen.
 */
const NoWebinars: React.FC<NoWebinarsProps> = ({
  title = "No upcoming webinars right now",
  subtitle = "New sessions are added regularly — check back soon to book your spot.",
  className = "",
}) => (
  <section
    className={`w-full bg-[#0E0E0E] flex flex-col items-center justify-center text-center px-5 py-24 md:py-32 min-h-[50vh] ${className}`}
  >
    <div
      className="flex items-center justify-center w-20 h-20 rounded-full mb-6"
      style={{ background: "rgba(51,153,255,0.10)" }}
    >
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none" aria-hidden>
        <rect
          x="3"
          y="4.5"
          width="18"
          height="16"
          rx="2.5"
          stroke="#3399FF"
          strokeWidth="1.6"
        />
        <path
          d="M3 9h18M8 2.5v4M16 2.5v4"
          stroke="#3399FF"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="m9.5 14.5 2 2 3.5-3.5"
          stroke="#FFBA08"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <h2 className="text-white font-semibold text-[22px] md:text-[28px]">
      {title}
    </h2>
    <p className="mt-3 text-[#8B95A1] text-[14px] md:text-[16px] max-w-[460px] leading-relaxed">
      {subtitle}
    </p>
  </section>
);

export default NoWebinars;
